import { motion } from 'motion/react';
import { cn } from '@reflex/ui/lib/utils';
import { Tooltip, TooltipTrigger, TooltipContent } from '@reflex/ui/components/ui/tooltip';
import { ACTIVITY_CONFIG } from '@/lib/status-colors';
import type { AgentActivity } from '@/lib/types';

export function ActivityDot({
  activity,
  showTooltip = false,
}: {
  activity: AgentActivity;
  showTooltip?: boolean;
}) {
  const cfg = ACTIVITY_CONFIG[activity];
  const isAnimated = activity === 'working' || activity === 'starting';
  const dotEl = (
    <motion.span
      layout
      data-testid="activity-dot"
      data-activity={activity}
      className={cn(
        'inline-block h-2 w-2 rounded-full transition-colors duration-300',
        cfg.dotColor,
        isAnimated && 'glow-active',
      )}
    />
  );

  if (!showTooltip) return dotEl;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex items-center">{dotEl}</span>
      </TooltipTrigger>
      <TooltipContent side="top">{cfg.sidebar.text}</TooltipContent>
    </Tooltip>
  );
}
